var map = {
	"./avery-logo.svg": 8571,
	"./favicons/icon-120.png": 9642,
	"./favicons/icon-128.png": 2489,
	"./favicons/icon-152.png": 7261,
	"./favicons/icon-16.png": 4426,
	"./favicons/icon-180.png": 3748,
	"./favicons/icon-192.png": 4202,
	"./favicons/icon-196.png": 4352,
	"./favicons/icon-32.png": 3285,
	"./favicons/icon-512.png": 6785,
	"./favicons/icon-96.png": 4570,
	"./label-volume-hm.png": 4872,
	"./label-volume-mm.png": 7943,
	"./label-volume.svg": 9160,
	"./label-weight-hm.png": 1441,
	"./label-weight-mm.png": 4270,
	"./label-weight.svg": 2573,
	"./logo-not-found.svg": 5563,
	"./recipal-icon.svg": 8112,
	"./recipal-logo-hat.svg": 2255,
	"./recipal-logo.svg": 105,
	"./serving-size-hint.png": 3540,
	"./serving-size.svg": 5117,
	"./watermark.svg": 4711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2929;